import React, { Component } from 'react';
import AuthService from '../services/auth';
import Api from '../services/api';
import { withRouter } from 'react-router-dom';
import './upgrade.css';
import LevelComparison from '../components/LevelComparison';
import withAuthorization from '../components/withAuthorization';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as routes from '../constants/routes';
import PaymentMethods from '../components/PaymentMethods';
import gem from '../static/vectors/gem-black.svg';

class promoUpgrade extends Component {

  constructor(props) {
    super(props);

    this.state = {
      chosenMethod: 'stripe',
      chosenOption: {
        key: 'promo_upgrade',
        name: 'PROMO SUPERIOR',
        price: 49.5,
      },
      options: {
        "superior_membership": {
          key: 'superior_membership',
          price: 59.5,
          discountPrice: 39.95,
          name: 'Superior membership',
          type: '1 month SUPERIOR',
          isDiscount: false,
        },
        "superior_membership1": {
          key: 'superior_membership1',
          price: 59.5,
          discountPrice: 27.75,
          name: 'Superior membership',
          type: '2 month SUPERIOR',
          isDiscount: true,
        }
      },
      lookingForTexts: {
        sugar_baby_a: 'sugarbabies',
        sugar_baby_m: 'sugarbabies',
        sugar_baby_f: 'sugarbabies',
        sugar_parent_a: 'sugar mommies or daddies',
        sugar_parent_m: 'sugar daddies',
        sugar_parent_f: 'sugar mommies',
      },
    };
  }

  componentDidMount() {
    const { setCurrentPage } = this.props;
    if(!AuthService.isLoggedIn()) {
      this.props.history.push(routes.JOIN);
    } else {
      (new Api()).get('/promo-upgrade-options', {}, AuthService.getAuthCookie())
        .then(response => {
          this.setState({
            options: response.options,
            chosenOption: response.options.promo_upgrade,
          });
        });
      setCurrentPage(routes.UPGRADE);
    }
  }

  handleRadioChange(value) {
    const { options } = this.state;
    this.setState({
      chosenOption: {
        key: value,
        price: (options[value].isDiscount)?options[value].discountPrice:options[value].price,
      },
    });
  }

  handleMethodChange(method) {
    this.setState({
      chosenMethod: method,
    });
  }

  render() {
    const { chosenOption, chosenMethod, lookingForTexts, options } = this.state;
    const { ucdUser } = this.props;
    const lookingForText = lookingForTexts[ucdUser.lookingFor];
    return (
      <div className="container search">
        {AuthService.isLoggedIn() && <div className="row">
          <div className="col col-12 upgrade">
            <div className="intro">
              <p className={'first-line'}>Hey <span className={'bold'}>{ucdUser.name}</span>,</p>
              <p>Do you want to view your received messages</p>
              <p>and chat with your {lookingForText}?</p>
            </div>
            <div className="sub-text">
              <p className={'uppercase bold'}>upgrade to superior member!</p>
              <p className={'uppercase'}>*PROMO ACTION - now free extra month!</p>
              <p className="lowercase">*For limited time</p>
            </div>
            <div className="payment">
              <div className="payment-options">
                {Object.keys(options).map(key => (
                  <div
                    key={key}
                    className={`payment-option ${(key.includes('upgrade') || key.includes('superior') || key.includes('pass'))? 'upgrade-option':''}`}
                    onClick={() => {this.handleRadioChange(key)}}
                  >
                    {(key.includes('upgrade') || key.includes('superior') || key.includes('pass')) && <div className="icon">
                      <img src={gem} alt="Superior" />
                    </div>
                    }
                    <div className="payment-option__checkbox">
                      <input
                        id={key}
                        type="radio"
                        name={'chosenOption'}
                        value={key}
                        onChange={(e) => {this.handleRadioChange(e.target.value);}}
                        checked={chosenOption.key === key}
                      />
                      <label htmlFor={key} />
                    </div>
                    <div className="payment-option__meta">
                      <div className="payment-option__name">
                        {options[key].title}
                      </div>
                      <div className="payment-option__price">
                        &#36;{(options[key].isDiscount)?options[key].discountPrice.toFixed(2):options[key].price.toFixed(2)}
                      </div>
                      {options[key].isDiscount &&
                      <div className="payment-option__price--striked">
                        &#36;{options[key].price.toFixed(2)}
                      </div>}
                      <div className="payment-option__type">
                        {options[key].type}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="payment-advantages">
                <LevelComparison
                  title={'SUperior advantages'}
                  levels={
                    [
                      'REGULAR (free)',
                      'PROMO SUPERIOR',
                    ]
                  }
                />
              </div>
              <PaymentMethods
                transactionType={'promo_upgrade'}
                ucdUser={ucdUser}
                price={(chosenOption.isDiscount)?chosenOption.discountPrice:chosenOption.price}
                chosenProduct={chosenOption.key}
                method={chosenMethod}
                onMethodChange={(method) => {this.handleMethodChange(method)}}
              />
            </div>
          </div>
        </div>}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  setCurrentPage: (page) => dispatch({ type: 'SET_CURRENT_PAGE', page }),
});

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(promoUpgrade);


// WEBPACK FOOTER //
// ./src/pages/promoUpgrade.js